// App.jsx - 메인 파일
import React from 'react';
import ClubInfosMain from './club_infos/ClubInfosMain';
import { useParams } from 'react-router';


function ClubInfosPage() {
  const { id } = useParams();
  return (
    <div className="w-full min-h-screen ">
      <ClubInfosMain />
    </div>
  );
}

export default ClubInfosPage;
